module.exports = require('./lib/chai');



/*****************
 ** WEBPACK FOOTER
 ** ./~/chai/index.js
 ** module id = 7
 ** module chunks = 1
 **/